module.exports = __webpack_public_path__ + "img/EZD_20260717_1.7c8cdfab.png";